import { Line } from '@ant-design/plots'
import { Empty } from 'antd'
import dayjs from 'dayjs'

const groupDataByMonth = (data) => {
  const result = {}

  data.forEach(({ date, count }) => {
    const monthKey = dayjs(date).format('YYYY-MM')
    result[monthKey] = (result[monthKey] || 0) + count
  })

  return Object.entries(result)
    .sort(([a], [b]) => dayjs(a).unix() - dayjs(b).unix())
    .map(([monthKey, count]) => ({
      date: dayjs(monthKey, 'YYYY-MM').format('MMM YY'),
      count,
    }))
}

const RedeemChart = ({
  data = [],
  theme = 'classicDark',
  chartHeight = 300,
  yAxisTitle = 'Total Points Redemption',
}) => {
  if (data.length === 0) {
    return (
      <div
        style={{
          height: chartHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Empty description="No data available" />
      </div>
    )
  }

  const sortedData = [...data].sort(
    (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix()
  )

  const displayData =
    sortedData.length > 50 ? groupDataByMonth(sortedData) : sortedData

  const isMonthly = sortedData.length > 50

  const config = {
    theme,
    data: displayData,
    xField: 'date',
    yField: 'count',
    height: chartHeight,
    autoFit: true,
    shapeField: 'smooth',
    scale: {
      y: { domainMin: 0 },
    },
    axis: {
      y: {
        title: yAxisTitle,
        grid: null,
      },
      x: {
        grid: null,
      },
    },
    xAxis: {
      label: {
        autoRotate: true,
        formatter: (val) => (isMonthly ? val : dayjs(val).format('DD MMM')),
      },
      tickCount: isMonthly ? undefined : Math.min(displayData.length, 15),
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
    padding: 'auto',
  }

  return <Line {...config} />
}

export default RedeemChart
